import {
    SPORTS_LIST,
    SPORTS_LIST_SUCCESS,
    SPORTS_LIST_FAILED,
    LEAGUE_LIST,
    LEAGUE_LIST_SUCCESS,
    LEAGUE_LIST_FAILED
} from './../../constants/actionTypes';

import {sportsService} from "./services";

export const fetchSportsList = () => {
    return dispatch => {
        dispatch(request());
        sportsService.sportsList()
            .then(
                sports => {
                    dispatch(success(sports.data));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    }

    function request() {
        return {type: SPORTS_LIST, payload:[]};
    }
    function success(data) {
        return {type: SPORTS_LIST_SUCCESS, payload: data};
    }

    function failure(error) {
        return {type: SPORTS_LIST_FAILED, payload: []};
    };
};


export const fetchLeaguesList = (sportId) => {
    return dispatch => {
        dispatch(request());
        sportsService.leaguesList(sportId)
            .then(
                sports => {
                    dispatch(success(sports.data));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    }

    function request() {
        return {type: LEAGUE_LIST, payload:[]};
    }
    function success(data) {
        return {type: LEAGUE_LIST_SUCCESS, payload: data};
    }

    function failure(error) {
        return {type: LEAGUE_LIST_FAILED, payload: []};
    };
};
